import { useState } from "react";
import { api, notifyError } from "@/lib/api";
import { Calculator } from "@phosphor-icons/react";
import { Field, ResultPanel } from "./shared";

const TILES = [
  { key: "gain_at_exercise", label: "Gain at exercise", money: true },
  { key: "normal_total_tax", label: "Tax — normal options", money: true, color: "#E63946" },
  { key: "keep_total_tax", label: "Tax — under KEEP", money: true, color: "#00A86B" },
  { key: "estimated_saving", label: "Estimated saving", money: true, color: "#00A86B" },
  { key: "keep_cgt_on_disposal", label: "CGT on disposal", money: true },
];

export default function KEEPCalc({ onSaved }) {
  const [f, setF] = useState({ market_value: "", exercise_price: "", expected_sale_value: "", tax_year: new Date().getFullYear() });
  const [calc, setCalc] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const run = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/tax/calculate/keep", {
        market_value: Number(f.market_value),
        exercise_price: Number(f.exercise_price),
        expected_sale_value: Number(f.expected_sale_value || 0),
        tax_year: Number(f.tax_year),
      });
      setCalc(r.data);
      onSaved && onSaved();
    } catch (err) { notifyError(err); }
    finally { setBusy(false); }
  };

  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <form onSubmit={run} className="glass rounded-2xl p-6 space-y-4">
        <div>
          <div className="eyebrow mb-1">KEEP — Key Employee Engagement Programme</div>
          <p className="text-white/55 text-sm">Share options for SME employees: no income tax at exercise — CGT on disposal instead. See the saving vs normal options.</p>
        </div>
        <Field label="Market value at exercise (€)" type="number" step="0.01" required data-testid="keep-mv" value={f.market_value} onChange={(e) => set("market_value", e.target.value)} />
        <Field label="Exercise (strike) price (€)" type="number" step="0.01" required data-testid="keep-strike" value={f.exercise_price} onChange={(e) => set("exercise_price", e.target.value)} />
        <div className="grid grid-cols-2 gap-4">
          <Field label="Expected sale value (€)" type="number" step="0.01" data-testid="keep-sale" value={f.expected_sale_value} onChange={(e) => set("expected_sale_value", e.target.value)} hint="Optional — for CGT estimate." />
          <Field label="Tax year" type="number" data-testid="keep-year" value={f.tax_year} onChange={(e) => set("tax_year", e.target.value)} />
        </div>
        <button type="submit" disabled={busy} className="btn-gold w-full justify-center" data-testid="keep-calculate"><Calculator size={16} weight="fill" /> {busy ? "Calculating…" : "Calculate KEEP benefit"}</button>
      </form>
      {calc ? <ResultPanel calc={calc} tiles={TILES} /> : (
        <div className="glass rounded-2xl p-6 flex items-center justify-center text-white/40 text-sm text-center">Enter the option values to compare KEEP vs normal share-option tax.</div>
      )}
    </div>
  );
}
